import React, { useState } from 'react';
import { Icon } from 'components';
import { useSelector } from 'react-redux';
import { makeSelectUserData } from 'pages/AppManagement/selectors';
import { Avatar, Box, Chip, Divider, MenuItem, Skeleton, Stack, Typography } from '@mui/material';
import { Menu } from 'components/Menu/Menu';

const MarketerInformation = ({ handleLogout }: { handleLogout: () => void }) => {
  const userDetails = useSelector(makeSelectUserData());

  const [anchorEl, setAnchorEl] = useState<null | Element>(null);

  const handleOpen = (event: React.MouseEvent<Element>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  return (
    <Box>
      <Chip
        variant="outlined"
        onClick={handleOpen}
        avatar={
          userDetails?.marketer?.logo && userDetails?.marketer?.logo?.url ? (
            <img
              src={userDetails.marketer.logo.url}
              style={{
                objectFit: 'contain',
                height: '32px',
                width: '32px'
              }}
            />
          ) : (
            <Avatar sx={{ borderRadius: '8px', height: '32px', width: '32px' }}>
              {userDetails?.marketer?.name?.charAt(0)}
            </Avatar>
          )
        }
        label={userDetails?.marketer?.name || <Skeleton width={100} variant="text" sx={{ fontSize: 14 }} />}
        sx={{ color: 'white', borderRadius: '8px' }}
        onDelete={handleOpen}
        deleteIcon={<Icon name="arrow-down-1-outline" fill="#FFF" size="20" />}
      />

      <Menu
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        position={{
          anchorOrigin: { vertical: 'bottom', horizontal: 'right' },
          transformOrigin: { vertical: 'top', horizontal: 'right' }
        }}
      >
        <Box sx={{ my: 1.5, px: 2 }}>
          <Stack direction="row" gap={1.5}>
            {userDetails?.marketer?.logo && userDetails?.marketer?.logo?.url ? (
              <img
                src={userDetails.marketer.logo.url}
                style={{
                  height: '40px',
                  width: '40px',
                  objectFit: 'contain'
                }}
              />
            ) : (
              <Avatar sx={{ borderRadius: '8px', height: '32px', width: '32px' }}>
                {userDetails?.marketer?.name?.charAt(0)}
              </Avatar>
            )}
            <Stack direction="row" justifyContent="space-between" width="100%" alignItems="center">
              <Box>
                {userDetails?.marketer?.name ? (
                  <Typography variant="body2" fontWeight={600} noWrap>
                    {userDetails?.marketer?.name}
                  </Typography>
                ) : (
                  <Skeleton width={100} variant="text" sx={{ fontSize: '1rem' }} />
                )}

                {/* {userDetails?.profile?.businessEmail?.address ? (
                        <Typography
                          textOverflow="ellipsis"
                          variant="subtitle2"
                          fontWeight={500}
                          width={170}
                          sx={{ color: 'text.secondary' }}
                          noWrap
                        >
                          {userDetails?.profile?.businessEmail?.address}
                        </Typography>
                      ) : (
                        <Skeleton width={100} variant="text" sx={{ fontSize: 14 }} />
                      )} */}
              </Box>
              {/* <Icon name="arrow-down-1-outline" size="16" fill="#292D32" /> */}
            </Stack>
          </Stack>
        </Box>
        <Divider sx={{ mx: 2 }} />
        {/* <Stack sx={{ p: 1 }}>
                {MENU_OPTIONS.map(option => (
                  <ListItemButton
                    key={option.label}
                    onClick={() => localRedirect(option.href)}
                    selected={location.pathname === option.href}
                  >
                    <ListItemIcon sx={{ minWidth: 42 }}>
                      <Icon fill="none" name={option.icon} />
                    </ListItemIcon>
                    <ListItemText primaryTypographyProps={{ fontWeight: 500, color: '#000' }} primary={option.label} />
                  </ListItemButton>
                ))}
              </Stack>
              <Divider sx={{ mx: 2 }} /> */}
        <MenuItem onClick={handleLogout} sx={{ m: 1 }}>
          Logout
        </MenuItem>
      </Menu>
    </Box>
  );
};

export default MarketerInformation;
